<template lang="pug">
.step
  HighlightedTicket(
    class="d-none d-lg-flex"
    color="aqua"
    :text="text[0]"
    :icon="icons[0]"
  )
  svg(
    class="d-none d-lg-block"
    width="141"
    height="31"
    viewBox="0 0 141 31"
    fill="none" xmlns="http://www.w3.org/2000/svg"
  )
    path(d="M120.279 3L136.348 15.562L120.311 28.1788" stroke="#9497A8" stroke-width="5" stroke-miterlimit="10" stroke-linecap="round")
    path(d="M0.5 16H134.5" stroke="#9497A8" stroke-width="5" stroke-linejoin="round")
  HighlightedTicket(
    color="blue"
    :text="text[1]"
    :icon="icons[1]"
  )
</template>

<script>

import HighlightedTicket from '@/components/Home/HighlightedTicket.vue'

export default {
  name: 'ProcessStep',
  components: {
    HighlightedTicket
  },
  props: {
    text: {
      type: Array,
      default: () => ([
        'Focus on leveraging data available online',
        'Focus on leveraging data available online',
        'test'
      ])
    },
    icons: {
      type: Array,
      default: () => ([
        'Icon Strategic planning.svg',
        'Icon Strategic planning.svg',
        'Icon Strategic planning.svg'
      ])
    }
  }
}



</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

$color-title: #364149;
$color-subtitle: #767F86;

.step {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 55px;
  align-items: center;
}


</style>
